module.exports = __webpack_public_path__ + "media/newstyle/images/facebook-share-pink-6adffde411bf44a52becb0698245252b.svg";